import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { enterSpace } from '../../actions/spaces/EnterSpaceAction';
import { SpaceInfo } from '../../state/SpaceInfo';
import { MapDispatchToProps } from '../../utils/ConnectUtils';

export interface SpaceInfoProviderOwnProps {
  readonly spaceInfo: SpaceInfo;
}

export interface SpaceInfoProviderDispatchProps {
  readonly enterSpace: (spaceInfo: SpaceInfo) => void;
}

export type SpaceInfoProviderProps = SpaceInfoProviderOwnProps & SpaceInfoProviderDispatchProps;

export class SpaceInfoProvider extends React.PureComponent<SpaceInfoProviderProps> {
  constructor(props: SpaceInfoProviderProps) {
    super(props);
    props.enterSpace(props.spaceInfo);
  }

  render() {
    return <>{this.props.children}</>;
  }
}

const mapDispatchToProps: MapDispatchToProps<SpaceInfoProviderDispatchProps> = (dispatch) => bindActionCreators({
  enterSpace,
}, dispatch);

export const ConnectedSpaceInfoProvider: React.ComponentClass<SpaceInfoProviderOwnProps>
  = connect(null, mapDispatchToProps)(SpaceInfoProvider);
